import React from 'react';
import PropTypes from 'prop-types';

const StepTitle = ({ children, number, caption, onClick = null }) => (
  <div>
    {/* eslint-disable-next-line */}
    <h1
      className="items-center flex mt-8 mx-0 mb-2 relative w-full lg:mx-0 lg:my-8"
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      // eslint-disable-next-line
      tabIndex={onClick ? '0' : undefined}
    >
      <span className="tracking-[.0187rem] font-bold items-center bg-brand rounded-[50%] text-white hidden text-base h-8 leading-snug justify-center min-w-[2rem] w-8 lg:flex lg:left-[-3.25rem] lg:relative">
        {number}
      </span>
      <span className="text-xl font-bold text-gray lg:-left-8 lg:relative">
        {children}
      </span>
    </h1>

    {!!caption && <div className="text-sm mb-8 lg:-mt-8">{caption}</div>}
  </div>
);

StepTitle.propTypes = {
  caption: PropTypes.string,
  children: PropTypes.node.isRequired,
  number: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default StepTitle;
